import React from "react";

const DashboardFooter = () => {
  return (
    <footer className="border-t border-slate-200 bg-white/80 px-4 py-4 text-center text-xs text-slate-500 backdrop-blur-xl dark:border-white/10 dark:bg-slate-950/80 dark:text-slate-400 sm:px-6 lg:px-8">
      <p>
        © {new Date().getFullYear()} MonAppliAsso — Administration du portail
        associatif.
      </p>
    </footer>
  );
};

export default DashboardFooter;